import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useLogout from '../hooks/useLogout';

const Withdrawal = () => {
       const axiosPrivate = useAxiosPrivate();
       const navigateto = useNavigate();
       const logout = useLogout();
       const [password, setPassword] = useState('');
       const [isPasswordConfirmed, setIsPasswordConfirmed] = useState(false);
       const [count, setCount] = useState(1);

       // 비밀번호 확인 요청
       const handlePasswordCheck = async () => {
              try {
                     const response = await axiosPrivate.post('/user/my/password', { password },
                            {
                                withCredentials: true
                            }
                     );
              
                     if (response.data.isSuccess) {
                            setIsPasswordConfirmed(true);
                            setCount(count+1);
                     } else {
                            alert('비밀번호가 틀렸습니다.');
                     }
              } catch (error) {
                     console.error('Error checking password:', error);
              }
       };

       const handleWithdrawal = async () => {
              const confirmed = window.confirm("정말로 회원 탈퇴하시겠습니까?");
              if (!confirmed) return;

              try {
                     const response = await axiosPrivate.put('/user/withdrawal', {
                                   withCredentials: true
                            });
                     response.data && alert(response.data.message);
                     logout();
                     navigateto('/');
              } catch (err) {
                     console.error(err);
              }
       }

       return (
              <div className="vertical-flex-container-1">
                     <div className="position-center-box-2">
                            {!isPasswordConfirmed ? (
                                          <div>
                                                 <h2 style={{marginBottom:"25px"}}>비밀번호 확인</h2>
                                                 {/* <label htmlFor="password" style={{marginRight:"7px"}}>비밀번호</label>  */}
                                                 <input
                                                        id="password"
                                                        style={{width:"75%", height:"36px", marginRight:"7px", border: "1px solid lightgray"}}
                                                        type="password"
                                                        // placeholder="비밀번호를 입력하세요"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                 />
                                                 <button className='button' onClick={handlePasswordCheck}>확인</button>
                                          </div>
                                   ) : (
                                          <div>
                                                 <div className="position-center-box-2-1">
                                                        <h2>회원 탈퇴</h2>
                                                 </div>
                                                 <br/>
                                                 <div className="position-center-box-2-1">
                                                        <p>티프매쓰는 세계 최대의 온라인 작도 문제를 기반으로 수학적 상상력과 창의적이고 체계적 구성력, 논리력, 치밀한 구현 능력을 강화하는 두뇌 활성화 플랫폼입니다.</p>
                                                        <p>티프매쓰에서는 2025년 4월 현재 약 3,000개의 활동 중심으로 탐구적 초등수학 문제와 6,000개의 온라인 작도 문제를 난이도와 주제별로 제공하고 있습니다.</p>
                                                        <p>회원 탈퇴를 하시면 그동안 티프매쓰에서 양으로 음으로 회원님의 두뇌 활동을 계발하고 활성화했던 모든 활동과의 연속성을 잃게 됩니다.</p>
                                                        <p>회원 탈퇴를 하시기 전에 일상 생활에 매몰되고 스마트폰과 AI에 의존하면서 점점 약해져가는 두뇌 활동을 연속성 있게 활성화하는 시간을 가져갈 필요가 있는 지 한 번 더 고민해 보시기를 바랍니다. </p>
                                                        <p>회원님이 티프매쓰 이용을 잠시 멈추시더라도 회원님의 정보는 티프매쓰((주)미래를여는생각) 내에서만 보관되고 개인정보 보호 정책에 따라 안전하게 관리됩니다.</p>
                                                 </div>
                                                 <div className="position-center-box-2-1">
                                                        <div className="horizontal-flex-container">
                                                               <button className="button" onClick={handleWithdrawal}>
                                                                      두뇌 활성화 시간을 잠시 멈추고 회원 탈퇴
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   )
                            }
                     </div>
              </div>
       );
}

export default Withdrawal;